const sameDay = (value, date) => {
  if (!value) return false;
  const d = value instanceof Date ? value : new Date(value);
  return d.getFullYear() === date.year && d.getMonth() === date.month && d.getDate() === date.day;
};

export function isCalendarBound(value, date) {
  if (Array.isArray(value)) return sameDay(value[0], date) || sameDay(value[1], date);
  return sameDay(value, date);
}
